import { forwardRef } from "react";

import { Form } from "@shared/components";
import { FormAutocompleteProps } from "@shared/components/Form/types";
import { listDiscountsService } from "@modules/discounts/services/queries/listDiscounts/service";

export const DiscountsAutocomplete = forwardRef<
  HTMLInputElement,
  Omit<FormAutocompleteProps, "options">
>((props, ref) => {
  return (
    <Form.Autocomplete {...props} ref={ref} queryHook={listDiscountsService} />
  );
});

DiscountsAutocomplete.displayName = "DiscountsAutocomplete";
